module.exports = __webpack_public_path__ + "img/IMG_2382.20746f32.jpg";